'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _subscriptions = require('../../redux/modules/subscriptions');

var _components = require('../../components');

var _SubscriptionsContainer = require('./SubscriptionsContainer.scss');var styles = _interopRequireWildcard(_SubscriptionsContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Styles
var SubscriptionsContainer = function (_Component) {_inherits(SubscriptionsContainer, _Component);function SubscriptionsContainer() {var _temp, _this, _ret;_classCallCheck(this, SubscriptionsContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.







    updateSubscription = function (subscriptionsIds, state) {
      _this.props.updateSubscriptionsTopics && _this.props.updateSubscriptionsTopics({
        access_token: _this.props.userToken,
        topics_ids: subscriptionsIds,
        enable: state,
        is_realtor: _this.props.isAgent });

    }, _this.

    renderList = function () {return (
        _react2.default.createElement(_components.SubscriptionsList, {
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          translate: _this.props.translate,
          updateSubscription: _this.updateSubscription,
          dataList: _this.props.topics,
          isAgent: _this.props.isAgent }));}, _temp), _possibleConstructorReturn(_this, _ret);}SubscriptionsContainer.prototype.componentWillMount = function componentWillMount() {this.props.loadSubscriptionsTopics && this.props.loadSubscriptionsTopics({ access_token: this.props.userToken, isAgent: this.props.isAgent });};SubscriptionsContainer.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        !this.props.withoutTitle &&
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement(_components.OMTitle, {
            title: this.props.translate('editProfile', 'mySubscriptions'),
            className: 'pageTitle' })),



        _react2.default.createElement('div', { className: styles.subscriptionList },
          !this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.titles },
            _react2.default.createElement('div', null, this.props.translate('mySubscriptions', 'title')),
            _react2.default.createElement('div', null, this.props.translate('mySubscriptions', 'status'))),


          this.props.loading ?

          _react2.default.createElement('div', { className: styles.spinnerPosition },
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) })) :

          this.renderList())));




  };return SubscriptionsContainer;}(_react.Component);


SubscriptionsContainer.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  withoutTitle: _propTypes2.default.bool,
  updateSubscriptionsTopics: _propTypes2.default.func,
  loadSubscriptionsTopics: _propTypes2.default.func,
  userEmail: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  isAgent: _propTypes2.default.bool,
  topics: _propTypes2.default.array };



var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    userEmail: (0, _get2.default)(state, 'userAuthentication.data.email'),
    isAgent: (0, _get2.default)(state, 'userAuthentication.data.is_agent'),
    topics: state.subscriptions.topics,
    loading: state.subscriptions.loading };};


var mapDispatchToProps = {
  loadSubscriptionsTopics: _subscriptions.loadSubscriptionsTopics,
  updateSubscriptionsTopics: _subscriptions.updateSubscriptionsTopics };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
SubscriptionsContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SubscriptionsContainer/SubscriptionsContainer.js
// module id = 3059
// module chunks = 0